import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

// 2026-09-24 (Jaime ruling): create-your-unit nudge for truly home-less users
// (has_units === false). A dismissible, non-blocking empty-state card on the
// home dashboard and home module empty states. The CTA reuses the EXISTING
// unit-creation flow: it deep-links to /profile?createUnit=1, which opens the
// "Crear propiedad" form (POST /api/units, spec E7 address contract) in
// EdicionPerfil — no new creation path is introduced.
const DISMISS_KEY = 'vecindus_create_home_nudge_dismissed_v1';

export default function CreateHomeNudge() {
  const { hasUnits, unitsLoaded } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  });

  // Only home-less users see it. Wait for hydration (unitsLoaded) so a unit
  // owner never flashes the card before /units/mine + memberships resolve.
  if (hasUnits || dismissed || !unitsLoaded) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div className="relative mb-5 flex flex-col gap-3 rounded-2xl border border-[var(--v-teal-600)]/30 bg-[var(--v-surface-1)] p-4 pr-10 sm:flex-row sm:items-center sm:pr-4">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[var(--v-teal-600)]/10" aria-hidden="true">
        <Home className="h-5 w-5 text-[var(--v-teal-600)]" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-[var(--v-text-primary)]">Crea tu hogar en Vecindus</p>
        <p className="text-sm text-[var(--v-text-secondary)]">Crea tu hogar para guardar mascotas, tareas, compras y más — todo tuyo, privado.</p>
      </div>
      <button
        type="button"
        onClick={() => navigate('/profile?createUnit=1')}
        className="shrink-0 rounded-xl bg-[var(--v-teal-600)] px-4 py-2 text-sm font-semibold text-white hover:bg-[var(--v-teal-500)]"
      >
        Crear mi hogar
      </button>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Cerrar"
        className="absolute right-2 top-2 rounded-lg p-1.5 text-[var(--v-text-secondary)] hover:bg-[var(--v-surface-2)]"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
